import { render, staticRenderFns } from "./spider-window-friendmessage.vue?vue&type=template&id=70dfc18c&scoped=true&"
import script from "./spider-window-friendmessage.vue?vue&type=script&lang=js&"
export * from "./spider-window-friendmessage.vue?vue&type=script&lang=js&"
import style0 from "./spider-window-friendmessage.vue?vue&type=style&index=0&id=70dfc18c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dfc18c",
  null
  
)

export default component.exports